<template>
  <div class="scheduleList">
    <ScheduleItem
      v-for="item in list"
      :key="item.ident"
      :item="item"
      :locale="locale"
      :lang="lang" />
  </div>
</template>

<script>
import ScheduleItem from '@/components/FlightInfo/ScheduleItem.vue'
export default {
  name: 'ScheduleList',
  props: [
    'locale',
    'lang',
    'list'
  ],
  components: {
    ScheduleItem
  }
}
</script>
